<template>
<BaseModal :id="'inspection-score-report'" :title="`Inspection Score Report`" :size="'lg'" :message="message" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-12" @submit.prevent="qcInspectionScoreReport()">
            <FormDynamic
                :form_format="form_format"
                :form_data="form_data"
                :array_options="array_options"
                :for_update="false"
                :content_align_x="'sdsd'"
            >
            <template v-slot:start-fields>
                <div class="formdynamic__item col-md-6 py-o inspection-score-form" :style="`margin-top:20px`">
                    <div class="formdynamic__item__field">
                        <label class="modal-label input-date-template m-0" v-html="`Date Range:`"/>
                        <date-range-picker
                        class="d-block"
                        ref="picker"
                        v-model="form_data.date_range"
                        cancelLabel="Clear">
                            <template v-slot:input="picker" style="min-width: 350px;">
                                {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                            </template>

                            <div slot="footer" slot-scope="data" class="slot p-2">
                                <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                                {{ data.rangeText }}
                                </span>
                                <span style="margin-left: auto">
                                    <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                                </span>
                                <span style="margin-left: auto">
                                    <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                                </span>
                            </div>
                        </date-range-picker>
                    </div>
                </div>
            </template>
            <template v-slot:more-fields>
                <div class="formdynamic__item col-md-6 py-0">
                    <div class="row mb-0">
                        <div class="col-md-3 py-0">
                            <div class="formdynamic__item__field">
                                <label for="Fixtures/Beds:" class="modal-label" v-html="'Score:'"/>
                                <select size="" class="input-field custom-select" v-model="form_data.score_simbol">
                                    <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-9 py-0">
                            <div class="formdynamic__item__field">
                                <label class="modal-label invisible" v-html="'Score:'"/>
                                <input type="number" :min="0" class="form-control" v-model="form_data.score"/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            </FormDynamic>
            <CentralLiteButtons :save_text="'Generate Report'" />
        </form>
    </template>
</BaseModal>
</template>

    
      
      
    
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import FormDynamic from '@/components/FormDynamic'
import BaseModal from "@/components/BaseModal";
import FormResources from "./form_resources";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'

export default {
    name: "InspectionScoreReportModal",

    props: ["breadcrumb", "array_options", "rest_api"],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons,
        FormDynamic,
        DateRangePicker
    },

    data() {
        return {
            message: `The completed inspections have been sent to their respective associates. To resend a specific inspection, please choose the desired inspection and click the 'Send Inspection Copy' button.`,
            select_all: false,
            form_format: FormResources.form_format,
            form_data: FormResources.form_data,
            simbol_options: FormResources.simbol_options,
            rest_api_search: 'rooms_advanced_search'
        };
    },
    watch: {
        async 'form_data.building_id'(val)
        {
            this.form_data.level_id = ''

            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'building',
                }

                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.length)
                    {
                        setTimeout(() => {
                            this.array_options['level_id'] = response.data 
                        }, 300);
                        this.notyfMesg('Levels available for the selected building')
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        this.notyfMesg('No levels available for the selected building', 'error')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options['level_id'] = []
            }
        },

        async 'form_data.level_id'(val)
        {
            this.form_data.area_id = ''

            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'level',
                }
                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.length)
                    {
                        setTimeout(() => {
                            this.array_options['area_id'] = response.data
                        }, 300);
                        this.notyfMesg('Areas available for the selected level')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        this.notyfMesg('No areas available for the selected level', 'error')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options['area_id'] = []
            }
        },
    },

    methods: {
        close(event) {
            this.$emit("close", event);
        },

        clearRangeDate(data)
        {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) 
        {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        async qcInspectionScoreReport()
        {
            const form_data = {
                standard_report_id: 9,
                format: 'portrait',
                params: this.form_data
            }

            this.loader(true)

            const response = await this.postingByPost(`search_standard_reports`, form_data, 'inspection-score-report', false)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },

    },

    computed: {},

    mounted() {},
};
</script>
